import { extension } from '@infl-ts/util-url';
import { flow } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { nanoid } from 'nanoid';
export var generateRandomFilename = flow(extension, O.map(function (ext) {
  return ".".concat(ext);
}), O.getOrElse(function () {
  return '';
}), function (ext) {
  return "".concat(nanoid()).concat(ext);
});